var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"pa-6",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',{staticClass:"title-main"},[_vm._v("Users")])]),_c('v-col',[_c('admin-users-table')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }